/**
 * @file 多个GridView - 详情页
 * @modify zhangzhe(zhangzhe@baidu.com)
 */

import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {DU_PREFIX} from '../../_common/constants';
import GridView, {GridViewItem} from './GridView';

import './index.less';

const CLS_PREFIX = `${DU_PREFIX}-gridviews`;

export interface GridViewsItem {
    key?: string;
    title?: string;
    colCount?: number;
    items: GridViewItem[];
}

export interface GridViewsProps {
    labelWidth?: number;
    colCount?: number;
    withColon?: boolean;
    contents: GridViewsItem[];
    prefixCls?: string;
}

const GridViews: React.FunctionComponent<GridViewsProps> = props => {
    const {contents, labelWidth, colCount, withColon, prefixCls} = props;
    const prefixGridViewsCls = prefixCls ? `${prefixCls}-gridviews` : CLS_PREFIX;

    return (
        <div className={prefixGridViewsCls}>
            {_.map(contents, (content, index) => {
                const itemKey = content.key || index;
                return (
                    <div className={`${prefixGridViewsCls}-item ${prefixGridViewsCls}-item-${itemKey}`} key={itemKey}>
                        {content.title && (
                            <div className={`${prefixGridViewsCls}-item-title`}>{content.title}</div>
                        )}
                        <GridView
                            items={content.items}
                            labelWidth={labelWidth}
                            colCount={content.colCount || colCount}
                            withColon={withColon}
                            prefixCls={prefixCls}
                        />
                    </div>
                );
            })}
        </div>
    );
};

GridViews.defaultProps = {
    labelWidth: 100, // label宽度
    colCount: 2, // 每行几列
    withColon: true, // 是否显示冒号
    contents: []
};

GridViews.propTypes = {
    labelWidth: PropTypes.number,
    colCount: PropTypes.number,
    withColon: PropTypes.bool,
    contents: PropTypes.array.isRequired
};

export default GridViews;